// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"ad0392a0","453":"80d044cb"}[chunkId] + ".chunk.js";
};